import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import { MOBILE_SETTINGS, MOBILE_SETTINGS_VERSIONS } from '../constants/actionTypes'
import * as API from '../constants/api'

export const mobileSettingsVersions = createAsyncThunk(
  MOBILE_SETTINGS_VERSIONS,
  async (
    params: PayloadCreatorParams<`${typeof API.MOBILE_SETTINGS_VERSIONS}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.mobileSettingsVersions(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const mobileSettings = createAsyncThunk(
  MOBILE_SETTINGS,
  async (params: PayloadCreatorParams<`${typeof API.MOBILE_SETTINGS}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.mobileSettings(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const mobileSettingsVersionsClear = createAction(`${MOBILE_SETTINGS_VERSIONS}/clear`)
